// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1788":"3c5774a5","4814":"380aab5c","7590":"c824244c"}[chunkId] + ".chunk.css";
};